import Modal from "../../modals/Modal";
import OpportunityAddItemsForm from "../opportunity/OpportunityAddItemsForm";
import {useEffect, useState} from "react";
import number_format from "../../../utils/number_format";
import OpportunityItemsModal from "../../modals/opportunity/OpportunityItemsModal";
import {Accordion} from "react-bootstrap";
import {PartnerApi} from "../../../api/partner.api";
import {useTranslation} from "../../../hooks/useTranslation";

export default function VendorDetailWarehouseSalesItemForm({
                                                               handleClose,
                                                               products,
                                                               setCart,
                                                               setShowModal,
                                                           }) {
    const { t } = useTranslation();
    return (
        <div>

            <div className="row">
                <div className="col-md-4">
                    <img
                        className="mw-100 mb-4"
                        style={{
                            aspectRatio: "1 / 1",
                            objectFit: "contain",
                        }}
                        src={
                            PartnerApi.url +
                            "/product/" +
                            products.product_id +
                            "/image.jpg"
                        }
                        alt={products.product_type + " " + products.name}
                    />
                </div>
                <div className="col-md-8">
                    <h3 className="mb-4">SKU: {products.sku}</h3>
                    <p>
                        <strong>{t("vendors.inStock")}:</strong>{" "}
                        {products.warehouse_sale.length} {t("vendors.pieces")}
                        <br/>
                        <strong>{t("products.regularPrice")}:</strong>{" "}
                        {number_format(
                            products.warehouse_sale[0]
                                .catalog_price_in_sale_currency,
                            2,
                            ",",
                            "."
                        )}{" "}
                        {products.warehouse_sale[0].currency}
                    </p>
                </div>
            </div>
            <h3>{t("products.availableItems")}</h3>

            <table className="table table-bordered">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>{t("common.note")}</th>
                    <th>{t("products.clearancePrice")}</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {products.warehouse_sale?.map((sale, sale_key) => (
                    <tr key={sale_key}>
                        <td>
                            {sale.sn}
                            {sale.secondHand === 1 && (
                                <>
                                    &nbsp;
                                    <span className="badge badge-warning">
                                        {t("products.usedGoods")}
                                    </span>
                                </>
                            )}
                        </td>
                        <td>{sale.note}</td>
                        <td>
                            {number_format(sale.fixedPrice, 2, ",", ".")}{" "}
                            {sale.currency}
                        </td>
                        <td>
                            <button
                                onClick={() => {
                                    setShowModal(products.product_id);
                                    setCart([
                                        {
                                            product_id: products.product_id,
                                            name:
                                                products.product_family +
                                                " " +
                                                products.name,
                                            sku: products.sku,
                                            quantity: 1,
                                            sn: sale.sn,
                                        },
                                    ]);
                                }}
                                className="btn btn-primary btn-sm"
                            >
                                <i className="ki-duotone ki-purchase fs-3">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}
